import React from "react";
import { BetSelectionsListProps } from "./types";
import ExoticBetSelections from "./ExoticBetSelections";
import SimpleBetSelections from "./SimpleBetSelections";
import LegBetSelections from "./legBetSelections";

const BetSelectionsList = ({
  selectionsList,
  betTypeNames,
  isExoticBet,
  isLeg
}: BetSelectionsListProps) => {
  const columnCount = selectionsList.length;

  if (isExoticBet && columnCount > 1) {
    return (
      <ExoticBetSelections
        selectionsList={selectionsList}
        columnCount={columnCount}
        betTypeNames={betTypeNames}
      />
    );
  }
  if (isLeg) {
    return <LegBetSelections selectionsList={selectionsList} />;
  }
  return (
    <SimpleBetSelections
      selectionsList={selectionsList}
      betTypeNames={betTypeNames}
    />
  );
};

export default BetSelectionsList;
